<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品">
            <a-input v-if="this.params.id>0" :read-only="true" placeholder="请选择产品" v-decorator="[
          'productName',
          {initialValue:data.productName,rules: [{ required: true, message: '请选择产品' }]}]"></a-input>
            <a-input-search v-else :read-only="true" placeholder="请选择产品" enterButton="选择" @search="onProductSearch" v-decorator="[
          'productName',
          {initialValue:data.productName,rules: [{ required: true, message: '请选择产品' }]}]"></a-input-search>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编码">
            <a-input :read-only="true" placeholder="请选择产品" v-decorator="[
          'productCode',
          {rules: [{ required: false, message: '请选择产品' }],initialValue:data.productCode}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格">
            <a-input :read-only="true" placeholder="请选择产品" v-decorator="[
          'specDes',
          {rules: [{ required: false, message: '请选择产品' }],initialValue:data.specDes}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="活动数量">
            <a-input :read-only="this.params.isShow" type="number" :min="1" placeholder="请输入活动数量" v-decorator="[
          'quantity',
          {rules: [{ required: true, message: '请输入活动数量' }],initialValue:data.quantity}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="活动价格">
            <a-input :read-only="this.params.isShow" type="number" :min="0.01" placeholder="请输入活动价格" v-decorator="[
          'activityPrice',
          {rules: [{ required: true, message: '请输入活动价格' }],initialValue:data.activityPrice}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
    <hp-manager-modal width="1300px" :title="'选择产品'" v-model="selectProductVisible">
      <hp-manager-page-product-select slot="slot" @getSelectedProduct="getSelectedProduct" @cancel="selectProductVisible = false" :params="{includeCustom:0}"></hp-manager-page-product-select>
    </hp-manager-modal>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import hpManagerPageProductSelect from "./../../Goods/Product/SelectProduct";
const defaultData = {
  id: 0,
  productName: "",
  productCode: "",
  specDes: "",
  quantity: "",
  activityId: 0,
  activityPrice: "",
  productId: ""
};
export default {
  name: "hp-manager-page-promotionProduct-add",
  mixins: [account, dateFormat],
  components: {
    hpManagerPageProductSelect
  },
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      selectProductVisible: false,
      productId: 0
    };
  },

  async mounted() {
    if (this.params.id > 0) {
      this.getPromotionProduct();
    } else {
      this.data = exzends(defaultData);
    }
    this.data.activityId = this.params.activityId;
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    onProductSearch() {
      this.selectProductVisible = true;
    },
    getSelectedProduct(p) {
      this.selectProductVisible = false;
      this.form.setFields({
        productName: { value: p.productName, errors: null }
      });
      this.form.setFields({
        productCode: { value: p.productCode, errors: null }
      });
      this.form.setFields({
        specDes: { value: p.specDes, errors: null }
      });
      this.productId = p.id;
    },
    async getPromotionProduct() {
      this.loading = true;
      let result = await api.GetPromotionProduct({ Id: this.params.id });
      if (result) {
        this.data = result;
        this.data.activityId = this.data.activityId;
        this.data.productId = this.data.productId;
        this.productId = this.data.productId;
        this.data.quantity = this.data.quantity + "";
        this.data.activityPrice = this.data.activityPrice + "";
      }
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        activityId: this.data.activityId,
        productId: this.productId,
        quantity: value.quantity,
        activityPrice: value.activityPrice
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        let data = await api.CreateOrUpdatePromotionProduct(requestData);
        if (this.params.id > 0) {
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Promotions/Activity/AddProduct.vue